<div class="d-flex justify-content-between align-items-center position-relative shadow-01" style="z-index: 2;">
  <div class="logo cursor-pointer" [routerLink]="'/superAdmin/dashboard/'">
    <img src="../../../assets/img/quuo-dashboard.svg">
  </div>

  <div class="logout" (click)="generalService.logOut()">
    <app-icon [align]="'center'" class="color-secondary">
      <i class="fal fa-sign-out cursor-pointer"></i>
    </app-icon>
  </div>
</div>

<main cdkScrollable class="position-relative " style="z-index: 1;">
  <router-outlet></router-outlet>
</main>